import React from 'react'
import { connect } from 'react-redux'
import { modalActions } from 'store/modal'
import { Loader } from 'components/UIElements'
import { announcementsActions } from '../modules/Announcements'
import AnnouncementsPage from '../components/AnnouncementsPage'
import { downloadInstrument, downloadTranslations } from '../../../../Instruments/routes/InstrumentsPage/modules/Instruments'
import { saveInstrumentSitesForPromotion } from '../../../../Instruments/routes/Instrument/modules/Instrument'
//Sites/routes/SitesPage/modules/Sites
import { actions as siteActions } from '../../../../Sites/routes/SitesPage/modules/Sites'
import { getStudyVersionID, isVersionUatOrLive } from 'utils/studyConfigUtils'
import { USER_ROLES_MAP } from 'utils/constants'
import { getUserRoleByStudy } from 'utils/misc'

const mapState = state => {
  const { announcements, loading, study, studyLock, location, sites, user } = state
  const { locales, currentStudy, studyVersionList } = study
  const studyID = currentStudy.id
  const studyVersionID = getStudyVersionID(location)
  const currentUserRole = getUserRoleByStudy(user, studyID)
  const hasStudyPromotion = !!study?.currentStudy?.config?.study_promotion
  const isReadOnlyState =
    currentUserRole.includes(USER_ROLES_MAP.supportAgent) ||
    (hasStudyPromotion && isVersionUatOrLive(studyVersionList, studyVersionID))

  const getCurrentVersion = () => {
    return studyVersionList?.find(item => item?.version_id === studyVersionID)
  }

  const currentVersion = getCurrentVersion()
  const currentVersionStatus = currentVersion?.version_status || ''
  const isCurrentDEV = currentVersion?.version_status?.toLowerCase() === 'dev'

  const isAllowedToEditAnnouncements = isCurrentDEV

  return {
    currentVersionStatus,
    loading: loading.general,
    locales,
    ...announcements,
    studyLock,
    communication: currentStudy.config?.communication,
    isClinro: currentStudy.config?.clinro,
    isReadOnlyState,
    hasStudyPromotion,
    isAllowedToEditAnnouncements,
    ...sites,
    studyID,
  }
}

const mapDispatch = {
  ...announcementsActions,
  ...modalActions,
  ...siteActions,
  saveInstrumentSitesForPromotion,
  downloadInstrument,
  downloadTranslations,
}

export default connect(
  mapState,
  mapDispatch,
)(props => {
  if (props.loading) return <Loader />
  return <AnnouncementsPage {...props} />
})
